var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConcentrationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2353_41383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.191785 1.22167L2.63664 4.0501L-0.191784 6.87853L6.87928 6.87853L6.87928 -0.192539L4.05086 2.63589L1.22243 -0.192539L-0.191785 1.22167Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1937 1.21874L21.7795 -0.195469L18.9511 2.63296L16.1227 -0.195468L16.1227 6.8756L23.1937 6.8756L20.3653 4.04717L23.1937 1.21874Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0528 16.4045L15.2227 23.2346L18.6868 21.2346L20.6868 24.6987L22.4188 23.6987L20.4188 20.2346L23.8829 18.2346L17.0528 16.4045Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58119 22.6987L3.31324 23.6987L5.31324 20.2346L8.77734 22.2346L6.94722 15.4045L0.11709 17.2346L3.58119 19.2346L1.58119 22.6987Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "#063554"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2353_41383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentrationIcon);
export default __webpack_public_path__ + "static/media/concentration-icon.cf451d9064439b4bfec8baf4c927b0b0.svg";
export { ForwardRef as ReactComponent };